<template>
  <v-card>
    <v-card-title class="headline top-title">Ajout d'un prospect</v-card-title>
    <v-card-text>
      <v-text-field
        label="Nom *"
        v-model="instance.name"
        data-vv-name="name"
        required
        v-validate="'required'"
        :error-messages="errors.collect('name')"
      ></v-text-field>
      <v-autocomplete
        v-model="instance.assignees.sale"
        :items="staff"
        persistent-hint
        label="Nom du commercial"
        data-vv-name="sale"
        :error-messages="errors.collect('sale')"
      ></v-autocomplete>
      <v-alert :value="showDuplicateError"> Le prospect existe déjà </v-alert>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="$emit('close')" color="grey">Annuler</v-btn>
      <v-btn flat @click="save()" color="primary" :disabled="loading"
        >Ajouter</v-btn
      >
    </v-card-actions>
    <v-snackbar v-model="showError" :timeout="7000">{{
      errorMessage
    }}</v-snackbar>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
const DEFAULT_VALUES = {
  name: "",
  assignees: {
    sale: "",
  },
};

export default {
  name: "ProspectAdd",
  data: function () {
    return {
      instance: { ...DEFAULT_VALUES },
      loading: false,
      showError: false,
      errorMessage: null,
      showDuplicateError: false,
    };
  },
  computed: {
    ...mapState("autocompletes", {
      allStaff: (p) => p.staff,
    }),
    staff() {
      return this.allStaff
        .filter(({ trigram }) => trigram != null)
        .map(({ firstName, lastName, trigram, email }) => ({
          text: `${trigram} - ${
            lastName
              ? firstName
                ? `${firstName} ${lastName}`
                : lastName
              : email
          }`,
          value: trigram,
        }));
    },
  },
  methods: {
    ...mapActions("prospects", ["saveProspect"]),

    async save() {
      if (!(await this.$validator.validate())) {
        return;
      }
      this.showDuplicateError = false;

      const prospect = await this.saveProspect(this.instance);
      if (prospect.statusCode === 400 && prospect.message === "duplicateName") {
        this.showDuplicateError = true;
      } else {
        this.$router.push(`/prospect/${prospect._id}`);
      }
    },
  },
};
</script>

<style>
h2 {
  color: grey;
  border-bottom: 1px solid grey;
  margin-bottom: 16px;
  margin-top: 8px;
}

.top-title {
  color: white;
  background: #60a694;
}
</style>
